// 存储检测到的 IP 地址
let detectedIpAddress: string = 'unknown';

/**
 * 获取已检测的 IP 地址
 */
export const getDetectedIpAddress = (): string => {
  return detectedIpAddress;
};

/**
 * 获取初始语言（立即返回，用于应用启动）
 */
export const getInitialLanguage = (): string => {
  // 优先使用已保存的语言
  const savedLanguage = localStorage.getItem('language');
  console.log('📱 Reading from localStorage - language:', savedLanguage);

  if (savedLanguage && ['en', 'vn', 'pl', 'it'].includes(savedLanguage)) {
    console.log(`📱 Using cached language: ${savedLanguage}`);
    return savedLanguage;
  }

  // 默认英语
  console.log('📱 Using default language: en');
  return 'en';
};

/**
 * 获取最终语言（异步检测，用于后台检测）
 */
export const getFinalLanguage = async (): Promise<string> => {
  try {
    // 检查是否有手动选择的语言
    const hasManualSelection = localStorage.getItem('language_manual_selection') === 'true';
    if (hasManualSelection) {
      const savedLanguage = localStorage.getItem('language');
      if (savedLanguage && ['en', 'vn', 'pl', 'it'].includes(savedLanguage)) {
        return savedLanguage;
      }
    }

    // 进行IP地理位置检测
    const response = await fetch('https://ipapi.co/json/');
    const data = await response.json();

    // 存储 IP 地址并打印详细信息
    if (data.ip) {
      detectedIpAddress = data.ip;
      console.log('========== IP Detection Result ==========');
      console.log('🌍 IP:', data.ip);
      console.log('🌍 Country:', data.country_name || data.country);
      console.log('🌍 Country Code:', data.country_code);
      console.log('🌍 City:', data.city);
      console.log('🌍 Region:', data.region);
      console.log('🌍 Timezone:', data.timezone);
      console.log('==========================================');
    }

    // 根据国家代码判断语言
    const vietnameseCountries = ['VN', 'Vietnam'];
    const polishCountries = ['PL', 'Poland'];
    const italianCountries = ['IT', 'Italy'];

    if (vietnameseCountries.includes(data.country_code) || vietnameseCountries.includes(data.country)) {
      return 'vn';
    }

    if (polishCountries.includes(data.country_code) || polishCountries.includes(data.country)) {
      return 'pl';
    }

    if (italianCountries.includes(data.country_code) || italianCountries.includes(data.country)) {
      return 'it';
    }

    return 'en';
  } catch (error) {
    console.error('❌ IP detection failed:', error);
    // 回退到已保存的语言或默认英语
    const savedLanguage = localStorage.getItem('language');
    return (savedLanguage && ['en', 'vn', 'pl', 'it'].includes(savedLanguage)) ? savedLanguage : 'en';
  }
};